module.exports = __webpack_public_path__ + "img/logo-whatsapp.d26517bc.png";